import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.62 8.10999C9.99 7.91999 10.44 7.97999 10.77 8.23999L14.6 11.37C14.85 11.58 15 11.89 15 12.22C15 12.55 14.86 12.86 14.6 13.07L10.8 16.24C10.48 16.51 10.03 16.57 9.65 16.39C9.27 16.21 9.03 15.82 9.03 15.4L9 9.09999C9 8.67999 9.24 8.28999 9.62 8.10999Z" fill={ fill || 'currentColor' }/>
    </svg>

);
